import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';

import LazyImage from '../LazyImage';
import Icon from '../Icon';

import { resultPropTypes } from './prop-types';
import PopOut from '../Form/PopOut';
import { GlobalsContext } from './context/globals';

const ResultCard = ({ className, result }) => {
  const {
    globals: { labels, defaultImageUrls },
  } = useContext(GlobalsContext);

  const classNames = ClassNames({
    [className]: className,
    WhatsOnResultCard: true,
    'WhatsOnResultCard-isPlaceOfInterest': result.isPlaceOfInterest,
  });

  const cardType = (() => {
    if (result.isPlaceOfInterest) {
      return labels.placeOfInterest;
    } else if (result.isMeet) {
      return labels.meet;
    } else if (result.isTemporaryHolidaySite) {
      return labels.temporaryHolidaySite;
    }
    return labels.event;
  })();

  const imageSrc = (() => {
    if (result.imageUrl) {
      return result.imageUrl;
    }

    if (result.isMeet || result.isTemporaryHolidaySite) {
      return defaultImageUrls[1];
    }

    return defaultImageUrls[0];
  })();

  return (
    <div className={classNames}>
      <a className="WhatsOnResultCard_link" href={result.url}>
        {result.isMeet || result.isTemporaryHolidaySite ? (
          <div
            className={`MembersOnlyFlag MembersOnlyFlag-eventCta ${
              result.isMeet ? 'MembersOnlyFlag-red' : ''
            } ${result.isTemporaryHolidaySite ? 'MembersOnlyFlag-aqua' : ''}`}
          >
            <svg width="24" height="17" viewBox="0 0 24 17" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M23.911 16.66C23.911 16.745 23.7331 16.745 23.7331 16.66L23.6441 16.575L23.4662 17L23.5551 16.49L21.8647 15.3L21.5978 16.575H21.6867C21.9537 16.575 22.1316 16.745 22.2206 17H11.9889H1.75719C1.84616 16.745 2.0241 16.575 2.29101 16.575H2.37999L2.11307 15.3L0.422622 16.49L0.511585 17L0.333645 16.575L0.244682 16.66C0.155711 16.745 0.0667284 16.66 0.0667284 16.66C-0.0222428 16.575 -0.0222428 16.49 0.0667284 16.405L0.244682 16.235L0.0667284 15.895L0.333645 15.81V16.065L2.02411 14.875V14.79C3.00279 13.685 5.93884 9.69 8.16312 6.375C9.7646 3.91 11.0992 1.53 11.9889 0C12.8786 1.53 14.2132 3.91 15.8146 6.375C17.95 9.69 20.975 13.77 21.9537 14.79V14.875L23.6441 16.065L23.7331 15.81L24 15.895L23.8221 16.235L24 16.405C24 16.49 24 16.575 23.911 16.66ZM15.2808 16.49C14.658 15.13 14.0352 13.77 13.5014 12.325C12.8786 10.2 12.3448 7.99 11.9889 5.78C11.9889 5.695 11.8999 5.695 11.8999 5.695C11.8109 5.695 11.8109 5.695 11.8109 5.78C11.544 8.075 11.0102 10.2 10.2984 12.325C9.85356 13.77 9.23077 15.13 8.60797 16.49H11.8999H15.2808Z"
                fill="#fff"
              />
            </svg>
            <h6 className="MembersOnlyFlag_text">{cardType}</h6>
          </div>
        ) : (
          result.highlight &&
          result.highlight.id === 'member_event' && (
            <div className="MembersOnlyFlag MembersOnlyFlag-eventCta">
              <h6 className="MembersOnlyFlag_text">{result.highlight.name}</h6>
              <PopOut info={result.highlight.description}>
                <div className="MembersOnlyFlag_popOutHit">i</div>
              </PopOut>
            </div>
          )
        )}

        <LazyImage className="WhatsOnResultCard_image" src={imageSrc}>
          {result.isCancelled && (
            <div className="WhatsOnResultCard_cancelled h2">{labels.cancelled}</div>
          )}
        </LazyImage>

        <div className="WhatsOnResultCard_footer">
          <h5 className="WhatsOnResultCard_cardType">{cardType}</h5>

          {result.title && <h4 className="WhatsOnResultCard_title">{result.title}</h4>}
          {(result.date || result.time) && (
            <div className="WhatsOnResultCard_details">
              {result.date && <span className="WhatsOnResultCard_detail">{result.date}</span>}
              {result.time && <span className="WhatsOnResultCard_detail">{result.time}</span>}
            </div>
          )}

          <p className="WhatsOnResultCard_strap">{result.description && result.description}</p>

          <div className="WhatsOnResultCard_priceAndButton">
            {result.price && <h5 className="WhatsOnResultCard_price">{result.price}</h5>}

            <div className="WhatsOnResultCard_button Button Button-darkAqua">
              {labels.resultCtaButtonLabel}
            </div>
          </div>

          <Icon className="WhatsOnResultCard_arrow" name="Arrow" />
        </div>
      </a>
    </div>
  );
};

ResultCard.propTypes = {
  result: resultPropTypes,
  className: PropTypes.string,
};

export default ResultCard;
